<template>
  <AppRow>
    <PaymentLogo :logo="processor" />
    <div>
      <FormHeading :h="4">📲 {{ $tt('mobile_payment.header') }}</FormHeading>
      <ul>
        <li>
          {{ $tt('mobile_payment.instruction_1') }}
          <PriceSpan :price="total" />
        </li>
        <li>
          {{ $tt('mobile_payment.instruction_2', [mobilePayments!.phone]) }}
        </li>
      </ul>
    </div>
  </AppRow>
  <v-form :ref="setFormRef">
    <AppRow>
      <PhoneField
        v-model="data.phone"
        :rules="[required]"
        :label="$tt('mobile_payment.phone_label')"
        :hint="$tt('mobile_payment.phone_hint')"
      />
      <TextField
        v-model="data.id"
        :rules="[required]"
        :label="$tt('mobile_payment.transfer_id')"
        :hint="$tt('mobile_payment.transfer_id_hint')"
        persistent-hint
      />
    </AppRow>
    <AppBtn primary size="x-large" :disabled="!valid" :loading @click="proceed">
      {{ $tt('mobile_payment.proceed') }}
    </AppBtn>
  </v-form>
</template>

<script setup lang="ts">
import { formatPhone } from '~/helpers/format';
import { sendMobilePaymentAlert } from '~/helpers/http';
import { calcTotalPrice } from '~/helpers/price';
import type { MobilePaymentProcessor, VisaForm } from '~/types';

const props = defineProps<{
  form: VisaForm;
  processor: MobilePaymentProcessor;
}>();

const { currency, mobilePayments } = useBranch();
const { required } = useValidation();
const { setFormRef, loading, submit, valid } = useForm();
const { buildSuccessRoute } = useRouting();

const data = reactive({
  phone: props.form.client.phone,
  id: '',
});
const total = computed(() => calcTotalPrice(props.form, currency));

function proceed() {
  submit(async () => {
    const { form } = props;
    const success = await sendMobilePaymentAlert({
      formId: form.id,
      phone: formatPhone(data.phone),
      transferId: data.id,
      processor: props.processor
    });
    if (!success) return;
    const successPath = buildSuccessRoute(form.id, form.product.country, props.processor);
    useRouter().push(successPath);
  });
}
</script>